import { Action } from './Action/action';
import { ActionGroup } from './ActionGroup/action-group';
import { AssistantMessage } from './AssistantMessage/assistant-message';
import { CustomCard } from './CustomCard/custom-card';
import { CustomCardGroup } from './CustomCardGroup/custom-card-group';
import { FormRecap } from './FormRecap/FormRecap';
import { FormRecapError } from './FormRecapError/FormRecapError';
import { FormRecapSuccess } from './FormRecapSuccess/FormRecapSuccess';
import { FormRequest } from './FormRequest/FormRequest';
import { NotFound } from './NotFound/not-found';
import { StreamError } from './StreamError/StreamError';
import { UserMessage } from './UserMessage/user-message';

export const blocks = {
  action: Action,
  actionGroup: ActionGroup,
  assistantMessage: AssistantMessage,
  customCard: CustomCard,
  customCardGroup: CustomCardGroup,
  formRecap: FormRecap,
  formRecapError: FormRecapError,
  formRecapSuccess: FormRecapSuccess,
  formRequest: FormRequest,
  notFound: NotFound,
  error: StreamError,
  userMessage: UserMessage,
};
